import React from 'react';
import { usePlateEditorState } from '@udecode/plate';
import { DropdownMenu } from '@udecode/plate-floating';
import {
  useTableBordersDropdownMenuContentState,
  useTableStore,
} from '@udecode/plate-table';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getOnSelectTableBorderFactory } from './getOnSelectTableBorderFactory';
import { PopoverButton } from '../../components/button/PopoverButton';

export const PlateTableBordersMenu = () => {
  const editor = usePlateEditorState();
  const selectedCells = useTableStore().get.selectedCells();
  const {
    hasOuterBorders,
    hasBottomBorder,
    hasLeftBorder,
    hasNoBorders,
    hasRightBorder,
    hasTopBorder,
  } = useTableBordersDropdownMenuContentState();

  const getOnSelectTableBorder = getOnSelectTableBorderFactory(editor, selectedCells);

  const toggleBorder = (e, side) => {
    e.stopPropagation();
    getOnSelectTableBorder(side)();
  };

  return (
    <DropdownMenu.Content
      side="right"
      align="start"
      sideOffset={8}
      className="slate-popover slate-popover--table"
      style={{ zIndex: 40 }}
    >
      {!selectedCells && (
        <>
          <div>
            <DropdownMenu.Item>
              <PopoverButton
                className={clsx('button--checkmark', hasBottomBorder && 'selected')}
                onClick={(e) => toggleBorder(e, 'bottom')}
              >
                <FontAwesomeIcon
                  icon={['fal', 'border-bottom']}
                />
                <div>Bottom Border</div>
              </PopoverButton>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <PopoverButton
                className={clsx('button--checkmark', hasTopBorder && 'selected')}
                onClick={(e) => toggleBorder(e, 'top')}
              >
                <FontAwesomeIcon
                  icon={['fal', 'border-top']}
                />
                <div>Top Border</div>
              </PopoverButton>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <PopoverButton
                className={clsx('button--checkmark', hasLeftBorder && 'selected')}
                onClick={(e) => toggleBorder(e, 'left')}
              >
                <FontAwesomeIcon
                  icon={['fal', 'border-left']}
                />
                <div>Left Border</div>
              </PopoverButton>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <PopoverButton
                className={clsx('button--checkmark', hasRightBorder && 'selected')}
                onClick={(e) => toggleBorder(e, 'right')}
              >
                <FontAwesomeIcon
                  icon={['fal', 'border-right']}
                />
                <div>Right Border</div>
              </PopoverButton>
            </DropdownMenu.Item>
          </div>

          <div className="menu-separator"/>
        </>
      )}

      <div>
        <DropdownMenu.Item>
          <PopoverButton
            className={clsx('button--checkmark', hasNoBorders && 'selected')}
            onClick={(e) => toggleBorder(e, 'none')}
          >
            <FontAwesomeIcon
              icon={['fal', 'border-none']}
            />
            <div>No Border</div>
          </PopoverButton>
        </DropdownMenu.Item>
        <DropdownMenu.Item>
          <PopoverButton
            className={clsx('button--checkmark', hasOuterBorders && 'selected')}
            onClick={(e) => toggleBorder(e, 'outer')}
          >
            <FontAwesomeIcon
              icon={['fal', 'border-outer']}
            />
            <div>Outside Borders</div>
          </PopoverButton>
        </DropdownMenu.Item>
      </div>
    </DropdownMenu.Content>
  );
};
